import { ProductApiModel } from '../models/ProductModel';
import { User } from '../models/UserModels';

const findDuplicatingProduct = (
  users: User[],
  products: ProductApiModel[],
): string | null => {
  const usersWithProducts = users.filter(
    (user) => user.assignedProducts && user.assignedProducts.length > 0,
  );

  const allAssignedProducts = usersWithProducts.flatMap(
    (user) => user.assignedProducts,
  );

  const duplicateProduct = allAssignedProducts.find((assignedProduct) =>
    products.some((product) => product.name === assignedProduct.name),
  );

  return duplicateProduct ? duplicateProduct.name : null;
};

export default findDuplicatingProduct;
